// PeptideVault v6.5 — Init + AI helper

// ══════════════════════════════════════════════════════
// INIT
// ══════════════════════════════════════════════════════

// ── Confirm dialogs (must be global scope) ──
function asyncConfirm(message) {
return new Promise(resolve => {
const overlay = document.createElement('div')
overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;-webkit-app-region:no-drag'
const lines = message.split('\n').map(l => '<div>'+l.replace(/</g,'&lt;')+'</div>').join('')
overlay.innerHTML = `<div style="background:var(--bg);border-radius:var(--r3,12px);padding:20px 24px;max-width:min(420px,calc(100vw - 32px));box-shadow:0 8px 32px rgba(0,0,0,.2)">
    <div style="font-size:14px;line-height:1.5;color:var(--text);margin-bottom:16px">${lines}</div>
    <div style="display:flex;gap:10px;justify-content:flex-end">
      <button class="btn btn-secondary" id="ac-cancel">Cancel</button>
      <button class="btn btn-primary" id="ac-confirm" style="background:var(--red);border-color:var(--red)">Confirm</button>
    </div>
  </div>`
document.body.appendChild(overlay)
overlay.querySelector('#ac-cancel').onclick = () => { overlay.remove(); resolve(false) }
overlay.querySelector('#ac-confirm').onclick = () => { overlay.remove(); resolve(true) }
overlay.addEventListener('click', e => { if (e.target === overlay) { overlay.remove(); resolve(false) } })
})
}
function appConfirm(message, onYes) {
const overlay = document.createElement('div')
overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;-webkit-app-region:no-drag'
const lines = message.split('\n').map(l => `<div>${l.replace(/</g,'&lt;')}</div>`).join('')
overlay.innerHTML = `<div style="background:var(--bg);border-radius:var(--r3,12px);padding:20px 24px;max-width:min(420px,calc(100vw - 32px));box-shadow:0 8px 32px rgba(0,0,0,.2)">
<div style="font-size:14px;line-height:1.5;color:var(--text);margin-bottom:16px">${lines}</div>
<div style="display:flex;gap:10px;justify-content:flex-end">
<button class="btn btn-secondary" id="ac-cancel">Cancel</button>
<button class="btn btn-primary" id="ac-confirm" style="background:var(--red);border-color:var(--red)">Confirm</button>
</div>
</div>`
document.body.appendChild(overlay)
overlay.querySelector('#ac-cancel').onclick = () => overlay.remove()
overlay.querySelector('#ac-confirm').onclick = () => { overlay.remove(); onYes() }
overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove() })
}


// ── Clipboard copy ──
function copyToClipboard(text) {
  navigator.clipboard.writeText(text).then(() => showToast('Copied!')).catch(() => showToast('Copy failed'))
}


// ── Focus trapping for modals ──
function trapFocus(event) {
  if (!S.modal) return
  const overlay = document.querySelector('.overlay')
  if (!overlay) return
  const focusable = overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
  if (focusable.length === 0) return
  const first = focusable[0]
  const last = focusable[focusable.length - 1]
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus() }
  else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus() }
}

async function init() {

  // Keep every dropdown A-Z, including options added later by editors.
  installAlphabeticalDropdownSorting()

  // Paint immediately on mobile while IndexedDB and cloud domains load. Without
  // this shell, iOS displays an empty white screen during the startup pull.
  const startupRoot = document.getElementById('app')
  if (startupRoot && !startupRoot.innerHTML.trim()) {
    startupRoot.innerHTML = `<div role="status" aria-live="polite" style="min-height:100dvh;display:grid;place-items:center;padding:24px;background:#f7fafb;color:#17313d;font-family:IBM Plex Sans,-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif">
      <div style="display:grid;justify-items:center;gap:14px;text-align:center">
        <img src="app-icon.png" alt="" width="72" height="72" style="border-radius:18px">
        <div style="font-size:22px;font-weight:700">Peptide<span style="color:#08aeb8">Vault</span></div>
        <div style="font-size:13px;color:#607784">Loading your latest data…</div>
        <div style="width:156px;height:5px;overflow:hidden;border-radius:9px;background:#dce8eb"><i style="display:block;width:42%;height:100%;border-radius:inherit;background:#08aeb8;animation:pvStartup 1.15s ease-in-out infinite alternate"></i></div>
      </div>
      <style>@keyframes pvStartup{from{transform:translateX(-70%)}to{transform:translateX(210%)}}@media(prefers-color-scheme:dark){body{background:#071824!important}#app>div[role=status]{background:#071824!important;color:#eef8fa!important}}</style>
    </div>`
  }

  if (typeof isElectron !== 'undefined' && isElectron && window.api && window.api.onNotificationOpen) window.api.onNotificationOpen(function(tab){ setTab(tab || 'dashboard') })

  // Browser back button navigation
  window.addEventListener('popstate', e => {
    if (e.state?.tab) { S.tab = e.state.tab; render() }
  })

  // Global error handlers
  window.onerror = (msg, src, line) => { console.error('Global error:', msg, src, line); showToast('Error: ' + msg) }
  window.addEventListener('unhandledrejection', e => { console.error('Unhandled rejection:', e.reason); e.preventDefault() })

  // Keyboard shortcuts
  document.addEventListener('keydown', e => {
    const mod = e.metaKey || e.ctrlKey
    if (e.key === 'Tab' && S.modal) { trapFocus(e) }
    if (mod && e.key === 'f') { e.preventDefault(); var si = document.querySelector('.search-input'); if (si) si.focus() }
    if (mod && e.key === 'k') { e.preventDefault(); openSearch() }
    if (mod && e.key === '/') { e.preventDefault(); toggleShortcuts() }
    if (mod && e.key === 's') { e.preventDefault(); save(); showToast('Saved') }
    if (e.key === 'Escape') { e.preventDefault(); if (typeof _shortcutsOpen!=='undefined'&&_shortcutsOpen) hideShortcutsOverlay(); else if (typeof _searchOpen!=='undefined'&&_searchOpen) closeSearch(); else if (S.modal) closeModal() }
  })

  // Offline detection
  window.addEventListener('online', () => { showToast('Back online'); if (!_localDirty && !_pushPending) pullOnly() })
  window.addEventListener('offline', () => showToast('Offline — changes saved locally'))

// ── Custom confirm modal (replaces browser confirm()) ──
  await initData()
  if (window.verifyDocumentFiles) await window.verifyDocumentFiles()
  // Load Anthropic key from safeStorage on Electron
  if (isElectron && window.api && window.api.loadCredential) {
    try {
      var cred = await window.api.loadCredential('anthropic')
      if (cred && cred.ok && cred.value) {
        // P0-1 FIX: Never put decrypted key in S.settings (it gets serialized to disk)
        S._anthropicKeyInMemory = cred.value
        S.settings._hasAnthropicKey = true
        S.settings.anthropicKey = '' // ensure no plaintext in settings object
      }
    } catch(e) { console.warn('safeStorage load failed:', e) }
  }

  // Installer-applied data migrations are real local edits. Queue their normal
  // authenticated push before startup pull can restore older cloud domains.
  if (S._pendingLocalDataMigration) {
    var pendingMigration = S._pendingLocalDataMigration
    S._pendingLocalDataMigration = ''
    await save()
    setTimeout(() => showToast('☁️ Syncing installed data update: ' + pendingMigration, 5000), 500)
  } else if (S.settings.cloudUrl && S.settings.cloudToken && S.settings.autoSyncEnabled) {
    // Establish the newest cloud revision before any render-time automation can
    // create a local edit. This is the normal zero-prompt new-device path.
    await pullOnly()
  }

  render()

  // If we had to recover from a backup at load, tell the user clearly
  if (S._loadedFromBackup) {
    setTimeout(() => showToast('⚠️ Main data file was unreadable — recovered from local backup. Verify your data.', 9000), 1200)
  }
  if (S._blockAutoPushUntilData) {
    setTimeout(() => showToast('No local data found. Pull from cloud or import a backup before adding data.', 9000), 1400)
  }

  // Take a once-per-session startup backup (best-effort, only if there's data)
  if (dataRecordCount() > 0) writeLocalBackup('startup')

  // Startup diagnostic — warn immediately if preload.js is stale
  if (isElectron && !window.api) {
    setTimeout(() => {
      showToast('⚠️ preload.js is outdated — copy all 3 src/ files and restart', 8000)
    }, 1000)
  }

  // ── Auto-sync: push immediately on save, pull on startup + focus ──
  if (S.settings.cloudUrl && S.settings.cloudToken && S.settings.autoSyncEnabled) {
    startPeriodicPull()
  }
  if (typeof notificationPreferences === 'function' && notificationPreferences().enabled) {
    setTimeout(() => syncNotificationSnapshot(true), 4500)
    setInterval(() => syncNotificationSnapshot(false), 30 * 60 * 1000)
  }
  // Pull on focus — only if no local edits pending
  let _focusPullTimer = null
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && S.settings.autoSyncEnabled) {
      clearTimeout(_focusPullTimer)
      _focusPullTimer = setTimeout(() => { if (!_localDirty && !_pushPending) pullOnly() }, 5000)
    }
  })
  window.addEventListener('focus', () => {
    if (S.settings.autoSyncEnabled) {
      clearTimeout(_focusPullTimer)
      _focusPullTimer = setTimeout(() => { if (!_localDirty && !_pushPending) pullOnly() }, 5000)
    }
  })
  // Auto-focus scanner input when on scanner tab
  document.addEventListener('keydown', (e) => {
    if (S.tab === 'scanner' && !S.modal && e.key !== 'Tab') {
      const input = document.getElementById('scan-hw-input')
      if (input && document.activeElement !== input) input.focus()
    }
  })
  // Close notif on outside click
  document.addEventListener('click', (e) => {
    if (S.notifOpen && !e.target.closest('.notif-btn') && !e.target.closest('.notif-dropdown')) {
      S.notifOpen = false; render()
    }
  })
}

// ── Injection CRUD ────────────────────────────────────
function deleteInjection(injId) {
  S.injections = S.injections.filter(i => i.id !== injId)
  save()
  // Re-show day detail if there are still injections for that day
  const remaining = S.modalData?.injs?.filter(i => i.id !== injId) || []
  if (remaining.length === 0) closeModal()
  else { S.modalData.injs = remaining; render() }
  showToast('Injection deleted')
}

// ── Mini calendar for peptide detail ─────────────────
function renderMiniCalendar(peptideId, peptideName) {
  const y = S.calYear, m = S.calMonth
  const today = new Date()
  const todayKey = dateKey(today.getFullYear(), today.getMonth(), today.getDate())
  const pepInjs = injectionsForPeptide(peptideId, peptideName)
  const injDates = new Set(pepInjs.map(i => i.date))

  const firstDay = new Date(y, m, 1).getDay()
  const daysInMonth = new Date(y, m+1, 0).getDate()
  const daysInPrev  = new Date(y, m, 0).getDate()
  const color = peptideColor(peptideName)

  let cells = ''
  for (let i = firstDay - 1; i >= 0; i--) {
    cells += `<div class="cal-mini-cell" style="opacity:.3">${daysInPrev - i}</div>`
  }
  for (let d = 1; d <= daysInMonth; d++) {
    const key = dateKey(y, m, d)
    const hasInj = injDates.has(key)
    const isToday = key === todayKey
    cells += `<div class="cal-mini-cell ${hasInj?'has-inj':''} ${isToday?'today':''}"
      style="${hasInj?`background:${color}22;color:${color}`:''}"
      ${hasInj?`onclick="showDayDetail('${key}')" title="${pepInjs.filter(i=>i.date===key).map(i=>fmt12(i.time)+' '+i.dosage).join(', ')}"`:''}>
      ${d}
    </div>`
  }
  const totalCells = firstDay + daysInMonth
  const remaining = totalCells % 7 === 0 ? 0 : 7 - (totalCells % 7)
  for (let d = 1; d <= remaining; d++) cells += `<div class="cal-mini-cell" style="opacity:.3">${d}</div>`

  const monthInjs = pepInjs.filter(i => i.date.startsWith(`${y}-${String(m+1).padStart(2,'0')}`))

  return `
  <div style="background:var(--bg3);border:1px solid var(--border);border-radius:var(--r2);padding:14px">
    <div class="row" style="margin-bottom:8px">
      <button class="btn btn-ghost btn-xs" onclick="calPrev();render()">◀</button>
      <span style="font-size:13px;font-weight:700;flex:1;text-align:center">${MONTHS[m]} ${y}</span>
      <button class="btn btn-ghost btn-xs" onclick="calNext();render()">▶</button>
    </div>
    <div class="cal-mini-grid">
      ${DAYS.map(d=>`<div style="font-size:9px;font-weight:700;color:var(--text4);text-align:center;padding:2px">${d[0]}</div>`).join('')}
      ${cells}
    </div>
    <div style="margin-top:8px;font-size:12px;color:var(--text3)">
      ${monthInjs.length ? `${monthInjs.length} injection${monthInjs.length!==1?'s':''} this month` : 'No injections this month'}
    </div>
  </div>`
}

function saveAnthropicKeyFromSettings() {
  var key = (document.getElementById('settings-ai-key') || {}).value || ''
  if (!key) { if (typeof deleteAnthropicCredential === 'function') deleteAnthropicCredential(); render(); return }
  if (!key.startsWith('sk-ant-')) { showToast('Invalid key — should start with sk-ant-'); return }
  if (typeof setAnthropicCredential === 'function') setAnthropicCredential(key)
  showToast('API key saved')
  render()
}

async function testAnthropicConnection() {
  const el = document.getElementById('ai-test-result')
  if (el) el.textContent = 'Testing…'
  try {
    var result = await aiTestConnection()
    if (result.ok) {
      var status = getAIConfigurationStatus()
      if (el) el.innerHTML = '<span style="color:var(--green)">✅ Connected via ' + status.transport + ' — ' + (result.content || 'OK') + '</span>'
    } else {
      throw new Error(result.error || 'Unknown error')
    }
  } catch(e) {
    if (el) el.innerHTML = '<span style="color:var(--red)">❌ ' + e.message + '</span>'
  }
}

// ── AI Lab Import ─────────────────────────────────────
function saveAnthropicKey() {
  const key = document.getElementById('ai-key-input')?.value?.trim()
  if (!key || !key.startsWith('sk-ant-')) { showToast('Invalid key — should start with sk-ant-'); return }
  if (typeof setAnthropicCredential === 'function') setAnthropicCredential(key)
  render()
  showToast('API key saved securely')
}

const LAB_EXTRACT_PROMPT = `You are extracting lab test results from a medical document. Return ONLY a JSON object with this exact structure, no other text:

{
  "panelName": "Name of the lab panel or test",
  "date": "YYYY-MM-DD",
  "markers": [
    {
      "name": "Marker Name",
      "value": "numeric value as string",
      "unit": "unit of measurement",
      "refLow": "reference range low value or empty string",
      "refHigh": "reference range high value or empty string"
    }
  ]
}

Extract ALL test results/markers you can find. For the date, use the specimen collection date if available, otherwise the report date. For reference ranges, split "1.5-4.5" into refLow:"1.5" and refHigh:"4.5". If only one bound is given (e.g. "<150"), use that as refHigh with empty refLow (or vice versa). If no reference range is given, use empty strings for both.`

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result.split(',')[1])
    reader.onerror = () => reject(new Error('Failed to read file'))
    reader.readAsDataURL(file)
  })
}

async function handleAILabDrop(file) {
  if (!file) return
  if (typeof hasAnthropicCredential === 'function' ? !hasAnthropicCredential() : !S.settings.anthropicKey) { showToast('Configure AI in Settings first'); return }

  const status = document.getElementById('ai-lab-status')
  if (status) { status.style.display = 'block'; status.textContent = `Reading ${file.name} (${(file.size/1024).toFixed(0)}KB)…` }

  // AI routing handled by unified aiSendRequest

  try {
    const ext = file.name.split('.').pop().toLowerCase()
    let messages

    if (['png','jpg','jpeg','gif','webp'].includes(ext)) {
      if (status) status.textContent = 'Encoding image…'
      const base64 = await fileToBase64(file)
      const mediaType = ext === 'jpg' ? 'image/jpeg' : `image/${ext}`
      messages = [{
        role: 'user',
        content: [
          { type: 'image', source: { type: 'base64', media_type: mediaType, data: base64 } },
          { type: 'text', text: LAB_EXTRACT_PROMPT }
        ]
      }]
    } else if (ext === 'pdf') {
      if (status) status.textContent = `Encoding PDF (${(file.size/1024/1024).toFixed(1)}MB) — may take a moment…`
      const base64 = await fileToBase64(file)
      messages = [{
        role: 'user',
        content: [
          { type: 'document', source: { type: 'base64', media_type: 'application/pdf', data: base64 } },
          { type: 'text', text: LAB_EXTRACT_PROMPT }
        ]
      }]
    } else {
      const text = await file.text()
      messages = [{ role: 'user', content: LAB_EXTRACT_PROMPT + '\n\n```\n' + text.slice(0, 40000) + '\n```' }]
    }

    if (status) status.textContent = 'Sending to Claude — this may take 15–30 seconds…'

    let responseData

    // Use unified AI service
      var aiResult = await aiSendRequest({ model: 'claude-sonnet-4-6', maxTokens: 8192, messages: messages, feature: 'lab-import' })
      if (!aiResult.ok) throw new Error(aiResult.error || 'AI request failed')
      responseData = aiResult.raw || {}

    const text = aiResult.content || ''

    if (!text) {
      if (status) {
        status.innerHTML = `<div style="color:var(--red)">Empty response. Full API response:<br><pre style="font-size:10px;overflow:auto;max-height:120px;white-space:pre-wrap">${esc(JSON.stringify(responseData,null,2).slice(0,1000))}</pre></div>`
      }
      return
    }

    if (status) status.textContent = 'Parsing response…'

    // Try multiple JSON extraction strategies
    let parsed = null
    const strategies = [
      () => { const m = text.match(/```json\s*([\s\S]*?)\s*```/); return m ? JSON.parse(m[1]) : null },
      () => { const m = text.match(/```\s*([\s\S]*?)\s*```/);     return m ? JSON.parse(m[1]) : null },
      () => { const m = text.match(/(\{[\s\S]*\})/s);              return m ? JSON.parse(m[1]) : null },
      () => JSON.parse(text),
    ]
    for (const fn of strategies) {
      try { parsed = fn(); if (parsed?.markers) break } catch(e) {}
    }

    if (!parsed) {
      if (status) {
        status.style.display = 'block'
        status.innerHTML = `<div style="color:var(--red);margin-bottom:8px">⚠ Could not parse structured response. Claude said:</div>
          <textarea style="width:100%;height:160px;font-size:11px;font-family:var(--mono);background:var(--bg3);border:1px solid var(--border);border-radius:4px;padding:8px">${esc(text)}</textarea>
          <div style="font-size:12px;color:var(--text3);margin-top:6px">Try a text/CSV version of your results, or a clearer image.</div>`
      }
      return
    }

    if (!parsed.markers?.length) {
      if (status) { status.style.display = 'block'; status.textContent = '⚠ No markers found — Claude could not identify test results in this document.' }
      return
    }

    if (status) status.textContent = `✓ Found ${parsed.markers.length} markers — opening review…`

    openModal('aiLabReview', {
      panelName: parsed.panelName || file.name.replace(/\.[^.]+$/, ''),
      date:      parsed.date || localDateKey(),
      markers:   parsed.markers.map(m => ({ id: uid(), ...m }))
    })

  } catch (e) {
    if (status) status.style.display = 'none'
    showToast('AI extraction failed: ' + e.message, 6000)
    console.error('AI lab import error:', e)
  }
}

// ══════════════════════════════════════════════════════
// SHARED AI HELPER — used by lab import and protocol import
// ══════════════════════════════════════════════════════
const SUPP_CSV_HEADERS = [
  'Name', 'Strength', 'Form', 'Brand', 'Category', 'Subcategory',
  'Qty On Hand (pills)', 'Serving Size (pills per dose)',
  'Serving AM', 'Serving PM',
  'Time of Day (am/noon/pm/both/protocol)', 'Taken By (todd/meagan/both)',
  'Dosages Different', 'User Dosages JSON',
  'Expiry Date (YYYY-MM-DD)', 'Low Stock Alert (days)',
  'Reorder URL', 'Notes', 'Status', 'Linked Protocol IDs', 'Linked Protocol Names', 'Depletion Action', 'Replaced By ID', 'Replacement Name', 'Replacement Note', 'Discontinued At', 'NIIMBOT Label', 'NIIMBOT QR'
]

function downloadSuppTemplate() {
  const example = [
    'Magnesium Glycinate', '400mg', 'Capsule', 'Thorne', 'Sleep & Stress', 'Magnesium',
    '180', '2', '', '', 'pm', 'both', 'false', '',
    '', '14', 'https://amazon.com/...', 'Take with dinner', 'active', '', '', 'keep', '', '', '', '', '⊙abc123⊙', '⊙def456⊙'
  ]
  downloadTemplateCSV('Supplements_Template.csv', SUPP_CSV_HEADERS, example)
}

function importSuppCSV() {
  const input = document.createElement('input')
  input.type = 'file'; input.accept = '.csv'
  input.onchange = e => {
    const file = e.target.files[0]; if (!file) return
    const reader = new FileReader()
    reader.onload = ev => parseSuppCSV(ev.target.result)
    reader.readAsText(file)
  }
  input.click()
}

async function parseSuppCSV(text) {
  const lines = text.trim().split('\n').filter(l => l.trim())
  if (lines.length < 2) { showToast('CSV must have a header row and at least one data row'); return }

  // Parse header to map column indices (case-insensitive, flexible)
  const rawHeader = lines[0].split(',').map(h => h.replace(/^"|"$/g,'').trim().toLowerCase())
  const col = name => rawHeader.findIndex(h => h.includes(name))

  const iName    = col('name')
  const iStrength= col('strength')
  const iForm    = col('form')
  const iBrand   = col('brand')
  const iCat     = col('category')
  const iSubcat  = rawHeader.findIndex(h => h.includes('subcategory'))
  const iQty     = col('qty')
  const iServing = col('serving')
  const iServingAM = rawHeader.findIndex(h => h.includes('serving am'))
  const iServingPM = rawHeader.findIndex(h => h.includes('serving pm'))
  const iTime    = col('time')
  const iBy      = col('taken')
  const iExpiry  = col('expiry')
  const iLow     = col('low stock')
  const iURL     = col('url') !== -1 ? col('url') : col('reorder')
  const iNotes   = col('notes')
  const iStatus  = col('status')
  const iLinkedProtocolIds = rawHeader.findIndex(h => h.includes('linked protocol ids'))
  const iLinkedProtocolNames = rawHeader.findIndex(h => h.includes('linked protocol names'))
  const iDepletionAction = rawHeader.findIndex(h => h.includes('depletion action') || h.includes('when stock reaches zero'))
  const iDosagesDifferent = rawHeader.findIndex(h => h.includes('dosages different'))
  const iUserDosages = rawHeader.findIndex(h => h.includes('user dosages'))
  const iReplacedBy = rawHeader.findIndex(h => h.includes('replaced by'))
  const iNiimLabel = rawHeader.findIndex(h => h.includes('niimbot') && h.includes('label'))
  const iNiimQR = rawHeader.findIndex(h => h.includes('niimbot') && h.includes('qr'))

  if (iName === -1) { showToast('CSV must have a "Name" column'); return }

  function parseField(row, idx) {
    if (idx === -1 || !row[idx]) return ''
    return row[idx].replace(/^"|"$/g, '').trim()
  }

  function parseRow(line) {
    // Handle quoted fields with commas inside
    const result = []
    let cur = '', inQuote = false
    for (let i = 0; i < line.length; i++) {
      const ch = line[i]
      if (ch === '"' && inQuote && line[i+1] === '"') { cur += '"'; i++ }
      else if (ch === '"') { inQuote = !inQuote }
      else if (ch === ',' && !inQuote) { result.push(cur); cur = '' }
      else cur += ch
    }
    result.push(cur)
    return result
  }

  const imported = [], skipped = []

  for (let i = 1; i < lines.length; i++) {
    const row = parseRow(lines[i])
    const name = parseField(row, iName)
    if (!name) { skipped.push(i+1); continue }

    const timeRaw = parseField(row, iTime).toLowerCase()
    const byRaw   = parseField(row, iBy).toLowerCase()
    const time    = timeRaw.includes('lunch') ? 'noon' : (['protocol','both','noon','am','pm'].find(v => timeRaw.includes(v)) || 'am')
    const by      = ['todd','meagan','both'].find(v => byRaw.includes(v)) || 'todd'
    const formRaw = parseField(row, iForm)
    const catRaw  = parseField(row, iCat)

    // Fuzzy match form — exact first, then partial
    const form = SUPP_FORMS.find(f => f.toLowerCase() === formRaw.toLowerCase())
           || SUPP_FORMS.find(f => f.toLowerCase().includes(formRaw.toLowerCase()) || formRaw.toLowerCase().includes(f.toLowerCase()))
           || formRaw

    // Fuzzy match category — exact first, then partial word match
    const cat = suppCategories().find(c => c.toLowerCase() === catRaw.toLowerCase())
          || suppCategories().find(c => {
              const needle = catRaw.toLowerCase()
              const haystack = c.toLowerCase()
              // Match if any word in needle matches any word in haystack
              const needleWords = needle.split(/[\s\/\-]+/).filter(w => w.length > 3)
              return needleWords.some(w => haystack.includes(w))
            })
          || catRaw

    var userDosages = {}
    try { userDosages = JSON.parse(parseField(row, iUserDosages) || '{}') } catch(e) {}
    const replacementId = parseField(row, iReplacedBy)
    const importedAction = parseField(row, iDepletionAction).toLowerCase()
    const depletionAction = ['keep','replace','discontinue'].includes(importedAction) ? importedAction : (replacementId ? 'replace' : 'keep')
    const importedProtocolIds = parseField(row, iLinkedProtocolIds).split(';').map(value => value.trim()).filter(Boolean)
    const importedProtocolNames = parseField(row, iLinkedProtocolNames).split(';').map(value => value.trim().toLowerCase()).filter(Boolean)
    const linkedProtocolIds = new Set(importedProtocolIds)
    importedProtocolNames.forEach(protocolName => {
      const match = (S.protocols || []).find(protocol => [protocol.sourceColumnName, protocol.peptideName, protocol.name].some(value => String(value || '').trim().toLowerCase() === protocolName))
      if (match) linkedProtocolIds.add(match.id)
    })
    imported.push({
      id:           's_' + uid(),
      name,
      strength:     parseField(row, iStrength),
      form,
      brand:        parseField(row, iBrand),
      category:     cat,
      subcategory:  parseField(row, iSubcat),
      quantityOnHand:  +(parseField(row, iQty)) || 0,
      dailyServing:    +(parseField(row, iServing)) || 1,
      servingAM:       parseField(row, iServingAM) === '' ? null : +(parseField(row, iServingAM)),
      servingPM:       parseField(row, iServingPM) === '' ? null : +(parseField(row, iServingPM)),
      timeOfDay:    time,
      takenBy:      by,
      dosagesDifferent: /^(true|yes|1)$/i.test(parseField(row, iDosagesDifferent)),
      userDosages: userDosages,
      expiryDate:   parseField(row, iExpiry),
      lowStockDays: +(parseField(row, iLow)) || 14,
      reorderUrl:   parseField(row, iURL),
      notes:        parseField(row, iNotes),
      status:       parseField(row, iStatus) || 'active',
      ...((iLinkedProtocolIds !== -1 || iLinkedProtocolNames !== -1) ? { linkedProtocolIds:[...linkedProtocolIds], linkedProtocolNames:parseField(row, iLinkedProtocolNames).split(';').map(value => value.trim()).filter(Boolean) } : {}),
      depletionAction,
      replacedBy:   depletionAction === 'replace' ? replacementId : '',
      niimLabel:    parseField(row, iNiimLabel),
      niimQR:       parseField(row, iNiimQR),
    })
  }

  if (!imported.length) { showToast('No valid rows found'); return }

  const dupes = imported.filter(s => S.supplements.some(x => x.name.toLowerCase() === s.name.toLowerCase()))
  const msg   = `Import ${imported.length} supplement${imported.length!==1?'s':''}?`
    + (dupes.length ? `\n\n${dupes.length} existing supplement${dupes.length===1?' will':'s will'} be updated by name.` : '')
    + (skipped.length ? `\n\nSkipped rows (no name): ${skipped.join(', ')}` : '')

  if (!await asyncConfirm(msg)) return

  let added = 0, updated = 0
  for (const item of imported) {
    const existing = S.supplements.find(x => x.name.toLowerCase() === item.name.toLowerCase())
    if (existing) { Object.assign(existing, item, { id:existing.id }); updated++ }
    else { S.supplements.push(item); added++ }
  }
  reconcileProtocolSupplementLinksFromImport()
  save(); render()
  showToast(`Supplements: ${added} added, ${updated} updated`)
}

function exportSuppCSV() {
  if (!S.supplements.length) { showToast('No supplements to export'); return }
  const sorted = [...S.supplements].sort((a,b) => a.name.localeCompare(b.name))
  const rows = [SUPP_CSV_HEADERS]
  sorted.forEach(s => {
    const replacement = s.replacedBy ? S.supplements.find(x => x.id===s.replacedBy) : null
    const replacementName = replacement ? `${replacement.name}${replacement.strength?' ('+replacement.strength+')':''}` : ''
    const depletionAction = s.depletionAction || (s.replacedBy ? 'replace' : 'keep')
    const replacementNote = depletionAction === 'discontinue' ? 'Discontinue when current stock reaches zero.' : s.replacedBy ? (replacementName ? `When current stock reaches zero, replace with ${replacementName}.` : `Replacement record ${s.replacedBy} could not be found.`) : ''
    rows.push([
    s.name,s.strength||'',s.form||'',s.brand||'',s.category||'',s.subcategory||'',
    s.quantityOnHand||0,s.dailyServing||1,s.servingAM??'',s.servingPM??'',s.timeOfDay||'',s.takenBy||'',
    s.dosagesDifferent?'true':'false',JSON.stringify(s.userDosages||{}),s.expiryDate||'',s.lowStockDays||14,s.reorderUrl||'',s.notes||'',s.status||'active',(s.linkedProtocolIds||[]).join(';'),[...(s.linkedProtocolNames||[]),...(s.linkedProtocolIds||[]).map(id => { const protocol=(S.protocols||[]).find(item=>item.id===id); return protocol?.sourceColumnName||protocol?.peptideName||protocol?.name||'' })].filter(Boolean).filter((name,index,names)=>names.indexOf(name)===index).join(';'),depletionAction,s.replacedBy||'',replacementName,replacementNote,s.discontinuedAt||'',s.niimLabel||'',s.niimQR||''
    ])
  })
  const stackSections = [
    ['Todd AM','todd','am'], ['Todd Noon','todd','noon'], ['Todd PM','todd','pm'], ['Todd Protocol','todd','protocol'],
    ['Meagan AM','meagan','am'], ['Meagan Noon','meagan','noon'], ['Meagan PM','meagan','pm'], ['Meagan Protocol','meagan','protocol'],
  ]
  stackSections.forEach(([label,person,time]) => {
    rows.push([])
    rows.push([label])
    rows.push(['Supplement','Strength','Form','Serving','Brand','Category','Notes'])
    const members = sorted.filter(s => ['active','phase_out','protocol'].includes(suppLifecycleStatus(s)) && suppIsActiveForPillPacks(s) && (s.takenBy===person||s.takenBy==='both') && suppMatchesTime(s, time))
    members.forEach(s => rows.push([s.name,s.strength||'',s.form||'',suppServingForTime(s,time),s.brand||'',s.category||'',s.notes||'']))
    if (!members.length) rows.push(['None'])
  })
  const csv = rows.map(r => r.map(c => '"' + String(c??'').replace(/"/g,'""') + '"').join(',')).join('\n')
  const date = localDateKey()
  if (window.api) {
    window.api.showSaveDialog({
      title: 'Export Supplements',
      defaultPath: `Supplements_${date}.csv`,
      filters: [{ name:'CSV', extensions:['csv'] }]
    }).then(p => { if (p) window.api.writeFile(p, csv).then(()=>showToast('Supplements exported')) })
  } else {
    const a = document.createElement('a')
    a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
    a.download = `Supplements_${date}.csv`
    a.click()
    showToast('Supplements exported')
  }
}

async function exportInjSuppliesCSV() {
  if (!S.injectionSupplies?.length) { showToast('No injection supplies to export'); return }
  const rows = [['Supply ID','Supply Name','Category','Description','Low-stock Threshold','SKU ID','Barcode','Vendor','Lot Number','Volume','Gauge','Needle Length','Size/Gauge','Expiration','Cost/EA','Reorder URL','Storage Locations','Stored Quantity','Transaction Quantity','Variance','Status','NIIMBOT Label','NIIMBOT QR']]
  for (const sup of S.injectionSupplies) {
    if (!(sup.skus||[]).length) {
      rows.push([sup.id||'',sup.name,sup.category||'',sup.description||'',sup.lowStockThreshold||0,'','','','','','','','','','','','',0,0,0,'Depleted','',''])
    }
    for (const sk of (sup.skus||[])) {
      const storedQty = (sk.locations||[]).reduce((total, placed) => total + Number(placed.qty||0), 0)
      const transactionQty = injSupplyQty(sk)
      const locations = (sk.locations||[]).map(placed => {
        const location = (S.storageLocations||[]).find(item => item.id === placed.locationId)
        return `${location?.name || placed.locationId || 'Unknown'}: ${Number(placed.qty||0)}`
      }).join('; ')
      const threshold = Number(sup.lowStockThreshold||0)
      const status = transactionQty <= 0 ? 'Depleted' : threshold > 0 && transactionQty <= threshold ? 'Low Stock' : 'In Stock'
      rows.push([
        sup.id||'',sup.name,sup.category||'',sup.description||'',threshold,sk.id||'',sk.barcode||'',sk.vendor||'',sk.lotNumber||'',
        sk.volume||'',sk.gauge||'',sk.needleLength||'',sk.sizeGauge||'',sk.expiryDate||'',sk.costPerUnit||'',sk.reorderUrl||'',
        locations,storedQty,transactionQty,storedQty-transactionQty,status,sk.niimLabel||'',sk.niimQR||''
      ])
    }
  }
  const csv = rows.map(r => r.map(v => '"' + String(v).replace(/"/g,'""') + '"').join(',')).join('\n')
  const filename = `PeptideVault_Supplies_Export_${localDateKey()}.csv`
  if (window.api) {
    const savePath = await window.api.showSaveDialog({ title:'Export Injection Supplies', defaultPath:filename, filters:[{name:'CSV',extensions:['csv']}] })
    if (savePath) { await window.api.writeFile(savePath, csv); showToast('Injection supplies exported') }
  } else {
    const a = document.createElement('a'); a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
    a.download = filename; a.click(); showToast('Injection supplies exported')
  }
}

// ── Supplement CRUD ───────────────────────────────────
function getSuppFormData() {
  const time = document.getElementById('f-supp-time')?.value || 'am'
  const daily = +(document.getElementById('f-supp-daily')?.value || 1)
  const amServ = +(document.getElementById('f-supp-serving-am')?.value || daily)
  const pmServ = +(document.getElementById('f-supp-serving-pm')?.value || daily)
  const depletionAction = document.getElementById('f-supp-depletion-action')?.value || 'keep'
  return {
    name:                document.getElementById('f-supp-name')?.value?.trim() || '',
    strength:            document.getElementById('f-supp-strength')?.value?.trim() || '',
    form:                document.getElementById('f-supp-form')?.value || '',
    brand:               document.getElementById('f-supp-brand')?.value?.trim() || '',
    category:            (document.getElementById('f-supp-cat')?.value === '__custom__' ? document.getElementById('f-supp-cat-custom')?.value?.trim() : document.getElementById('f-supp-cat')?.value) || '',
    subcategory:         (document.getElementById('f-supp-subcat')?.value === '__custom__' ? document.getElementById('f-supp-subcat-custom')?.value?.trim() : document.getElementById('f-supp-subcat')?.value) || '',
    quantityOnHand:      +(document.getElementById('f-supp-qty')?.value || 0),
    dailyServing:        time === 'both' ? amServ : daily,
    servingAM:           time === 'both' ? amServ : null,
    servingPM:           time === 'both' ? pmServ : null,
    timeOfDay:           time,
    takenBy:             document.getElementById('f-supp-by')?.value || 'todd',
    dosagesDifferent:    document.getElementById('f-supp-dosages-different')?.checked || false,
    userDosages: {
      todd: {
        am: document.getElementById('f-supp-dose-todd-am')?.value || '',
        noon: document.getElementById('f-supp-dose-todd-noon')?.value || '',
        pm: document.getElementById('f-supp-dose-todd-pm')?.value || '',
      },
      meagan: {
        am: document.getElementById('f-supp-dose-meagan-am')?.value || '',
        noon: document.getElementById('f-supp-dose-meagan-noon')?.value || '',
        pm: document.getElementById('f-supp-dose-meagan-pm')?.value || '',
      },
    },
    lowStockDays:        +(document.getElementById('f-supp-lowstock')?.value || 14),
    expiryDate:          document.getElementById('f-supp-expiry')?.value || '',
    reorderUrl:          document.getElementById('f-supp-url')?.value?.trim() || '',
    notes:               document.getElementById('f-supp-notes')?.value?.trim() || '',
    niimLabel:            document.getElementById('f-supp-niimlabel')?.value?.trim() || '',
    niimQR:               document.getElementById('f-supp-niimqr')?.value?.trim() || '',
    status:              document.getElementById('f-supp-status')?.value || 'active',
    linkedProtocolIds:   Array.from(document.getElementById('f-supp-protocol-links')?.selectedOptions || []).map(option => option.value).filter(Boolean),
    linkedProtocolNames: Array.from(document.getElementById('f-supp-protocol-links')?.selectedOptions || []).map(option => option.dataset.scheduleName).filter(Boolean).filter((name,index,names)=>names.indexOf(name)===index),
    depletionAction,
    replacedBy:          depletionAction === 'replace' ? (document.getElementById('f-supp-replacedby')?.value || '') : '',
  }
}

function toggleSuppDosageOverride() {
  const by = document.getElementById('f-supp-by')?.value
  const wrap = document.getElementById('f-supp-dosage-override-wrap')
  if (wrap) wrap.style.display = by === 'both' ? 'block' : 'none'
  const checked = document.getElementById('f-supp-dosages-different')?.checked
  const detail = document.getElementById('f-supp-dosage-detail')
  if (detail) detail.style.display = checked ? 'grid' : 'none'
}

function toggleSuppProtocolLinks() {
  const status = document.getElementById('f-supp-status')?.value
  const time = document.getElementById('f-supp-time')?.value
  const wrap = document.getElementById('f-supp-protocol-links-wrap')
  if (wrap) wrap.style.display = status === 'protocol' || time === 'protocol' ? 'block' : 'none'
}

function updateSuppCalc() {
  const qty   = +(document.getElementById('f-supp-qty')?.value || 0)
  const time  = document.getElementById('f-supp-time')?.value || 'am'
  const by    = document.getElementById('f-supp-by')?.value || 'todd'

  // Toggle split/single serving fields
  const single = document.getElementById('f-supp-serving-single')
  const split  = document.getElementById('f-supp-serving-split')
  if (single) single.style.display = time === 'both' ? 'none' : 'block'
  if (split)  split.style.display  = time === 'both' ? 'block' : 'none'

  const daily  = +(document.getElementById('f-supp-daily')?.value || 1)
  const amServ = +(document.getElementById('f-supp-serving-am')?.value || daily)
  const pmServ = +(document.getElementById('f-supp-serving-pm')?.value || daily)

  const dailyPerPerson = time === 'both' ? amServ + pmServ : daily
  const timeMult = time === 'both' ? 1 : 1
  const dosesPerDay = dailyPerPerson * (by === 'both' ? 2 : 1)
  const days = dosesPerDay > 0 ? Math.floor(qty / dosesPerDay) : null

  const el = document.getElementById('supp-calc-result')
  if (!el) return

  const timeLabel = SUPP_TIME[time] || time.toUpperCase()
  const byLabel   = by === 'both' ? 'Todd & Meagan' : by === 'todd' ? 'Todd' : 'Meagan'
  const servingDesc = time === 'both'
    ? `${amServ} AM + ${pmServ} PM = ${dailyPerPerson}/day`
    : `${daily} pill${daily!==1?'s':''}/dose`

  el.innerHTML = `
    <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:8px;text-align:center">
      <div><div style="font-size:18px;font-weight:700;color:var(--blue)">${qty}</div><div style="font-size:10px;color:var(--text4)">PILLS ON HAND</div></div>
      <div><div style="font-size:18px;font-weight:700;color:${days!==null&&days<=14?'var(--red)':days!==null&&days<=30?'var(--yellow)':'var(--green)'}">${days !== null ? days : '—'}</div><div style="font-size:10px;color:var(--text4)">DAYS SUPPLY</div></div>
    </div>
    <div style="font-size:11px;color:var(--text3);text-align:center;margin-top:8px">
      ${byLabel} · ${timeLabel} · ${servingDesc}${by==='both'?' × 2 people':''}
    </div>`
}

// ── Supplement Refill ─────────────────────────────────
function updateRefillCount() {
  let count = 0, total = 0
  document.querySelectorAll('[data-refill-id]').forEach(el => {
    const v = +(el.value || 0)
    if (v > 0) { count++; total += v }
  })
  const el = document.getElementById('refill-summary')
  if (el) {
    el.innerHTML = count
      ? `<strong>${count}</strong> supplement${count!==1?'s':''} to refill · <strong>${total}</strong> pills total will be added`
      : 'No refills entered yet'
  }
}

function refillFilterSet(mode) {
  document.querySelectorAll('[data-refill-row]').forEach(row => {
    row.style.display = (mode === 'low' && row.dataset.low !== '1') ? 'none' : ''
  })
}

function applyRefills() {
  const date = document.getElementById('refill-date')?.value || localDateKey()
  if (!S.refillLog) S.refillLog = []
  let applied = 0, totalAdded = 0
  document.querySelectorAll('[data-refill-id]').forEach(el => {
    const amount = +(el.value || 0)
    if (amount <= 0) return
    const s = S.supplements.find(x => x.id === el.dataset.refillId)
    if (!s) return
    const newTotal = (+(s.quantityOnHand||0)) + amount
    s.quantityOnHand = newTotal
    S.refillLog.push({ id:'rf_'+uid(), suppId:s.id, name:s.name, amount, newTotal, date, at:now() })
    applied++; totalAdded += amount
  })
  if (!applied) { showToast('Enter a refill amount for at least one supplement'); return }
  logChange('supplement', null, 'updated', `Refilled ${applied} supplement(s), +${totalAdded} pills (${date})`)
  save(); closeModal(); render()
  showToast(`Refilled ${applied} supplement${applied!==1?'s':''} (+${totalAdded} pills)`)
}

function saveAddSupplement() {
  const data = getSuppFormData()
  if (!data.name) { showToast('Supplement name is required'); return }
  if (data.depletionAction === 'replace' && !data.replacedBy) { showToast('Choose the replacement supplement'); return }
  const newSupp = { id: 's_'+uid(), ...data }
  S.supplements.push(newSupp)
  logChange('supplement', newSupp.id, 'created', `Added supplement "${data.name}"`)
  checkSupplementTransitions()
  save(); closeModal(); render(); showToast('Supplement added')
}

function saveEditSupplement(suppId) {
  const s = S.supplements.find(x => x.id === suppId)
  if (!s) return
  const data = getSuppFormData()
  if (!data.name) { showToast('Supplement name is required'); return }
  if (data.depletionAction === 'replace' && !data.replacedBy) { showToast('Choose the replacement supplement'); return }
  // Detect dosage changes for change log
  if (data.dosagesDifferent && JSON.stringify(s.userDosages) !== JSON.stringify(data.userDosages)) {
    logChange('supplement', s.id, 'updated', `Updated user-specific dosages for "${data.name}"`)
  }
  Object.assign(s, data)
  if (data.status === 'active') delete s.discontinuedAt
  checkSupplementTransitions()
  save(); closeModal(); render(); showToast('Supplement updated')
}

function deleteSupplement(suppId) {
  appConfirm('Delete this supplement?', () => {
    const s = S.supplements.find(x => x.id === suppId)
    S.supplements = S.supplements.filter(x => x.id !== suppId)
    if (s) logChange('supplement', suppId, 'deleted', `Deleted supplement "${s.name}"`)
    save(); render(); showToast('Supplement deleted')
  })
}

// ── User Profile CRUD ─────────────────────────────────
function getUserFormData() {
  return {
    name:     document.getElementById('f-user-name')?.value?.trim() || '',
    initials: document.getElementById('f-user-initials')?.value?.trim().toUpperCase() || '',
    color:    document.getElementById('f-user-color')?.value || '#0072B2',
    age:      document.getElementById('f-user-age')?.value || '',
    notes:    document.getElementById('f-user-notes')?.value?.trim() || '',
    active:   document.getElementById('f-user-active')?.checked !== false,
  }
}
function saveAddUser() {
  const data = getUserFormData()
  if (!data.name) { showToast('Name is required'); return }
  const id = data.name.toLowerCase().replace(/[^a-z0-9]/g,'-')
  const user = { id, ...data, initials: data.initials || data.name.slice(0,2).toUpperCase() }
  S.users.push(user)
  logChange('user', user.id, 'created', `Added user "${data.name}"`)
  save(); closeModal(); render(); showToast('User added')
}
function saveEditUser(userId) {
  const u = S.users.find(x => x.id === userId)
  if (!u) return
  const data = getUserFormData()
  if (!data.name) { showToast('Name is required'); return }
  Object.assign(u, data, { initials: data.initials || data.name.slice(0,2).toUpperCase() })
  logChange('user', u.id, 'updated', `Updated user "${data.name}"`)
  save(); closeModal(); render(); showToast('User updated')
}
function deleteUser(userId) {
  appConfirm('Delete this user? Supplements/protocols assigned to them will remain but unlinked.', () => {
    const u = S.users.find(x => x.id === userId)
    S.users = S.users.filter(x => x.id !== userId)
    if (u) logChange('user', userId, 'deleted', `Deleted user "${u.name}"`)
    save(); closeModal(); render(); showToast('User deleted')
  })
}

const PROTOCOL_DISCLAIMER = 'This summary contains user-entered information for personal organization and educational recordkeeping only. It is not medical advice, diagnosis, treatment guidance, or prescribing guidance. Always consult a qualified medical professional before making health-related decisions.'

function printProviderSummary() {
  const userId = document.getElementById('summary-user')?.value || 'all'
  const scope  = document.getElementById('summary-scope')?.value || 'full'
  const userName = userId === 'all' ? 'Household (Combined)' : (getUser(userId)?.name || userId)

  const supps = (S.supplements||[]).filter(s => (s.status||'active') === 'active' && (userId === 'all' || s.takenBy === userId || s.takenBy === 'both'))
  const peps  = S.peptides || []

  let body = `<h1>PeptideVault — Personal Record Summary</h1>
    <div style="font-size:13px;color:#666;margin-bottom:16px">
      <strong>${esc(userName)}</strong> · Generated ${new Date().toLocaleDateString()}
    </div>`

  if (scope !== 'supplements' && peps.length) {
    body += `<h2 style="font-size:15px;margin-top:20px">Active Peptides</h2>
      <table><thead><tr><th>Scientific Name</th><th>Vial Name</th><th>Qty</th></tr></thead><tbody>
      ${[...peps].sort((a,b)=>a.name.localeCompare(b.name)).map(p=>{
        const lib = findLibraryEntry(p.name)
        const qty = p.skus.reduce((s,sku)=>s+sku.transactions.reduce((t,tx)=>t+(tx.type==='in'?tx.qty:-tx.qty),0),0)
        return `<tr><td>${esc(p.name)}</td><td style="color:#666">${esc(p.customVialName||lib?.customVialName||'—')}</td><td>${qty}</td></tr>`
      }).join('')}
      </tbody></table>`
  }

  if (scope !== 'peptides' && supps.length) {
    body += `<h2 style="font-size:15px;margin-top:20px">Active Supplements</h2>
      <table><thead><tr><th>Name</th><th>Strength</th><th>Time</th><th>Serving</th><th>Taken By</th></tr></thead><tbody>
      ${[...supps].sort((a,b)=>a.name.localeCompare(b.name)).map(s=>{
        let serving = s.dailyServing||1
        if (s.timeOfDay==='both') serving = `${suppServingAM(s)} AM / ${suppServingPM(s)} PM`
        return `<tr><td>${esc(s.name)}</td><td>${esc(s.strength||'—')}</td><td>${esc(SUPP_TIME[s.timeOfDay]||s.timeOfDay)}</td><td>${serving}</td><td>${esc(SUPP_USER[s.takenBy]||s.takenBy)}</td></tr>`
      }).join('')}
      </tbody></table>`
  }

  body += `<div style="margin-top:24px;padding:12px;background:#f5f5f5;border-radius:8px;font-size:10px;color:#666;line-height:1.5">
    ${esc(PROTOCOL_DISCLAIMER)}</div>`

  const w = window.open('', '_blank')
  w.document.write(`<html><head><title>Personal Record Summary</title>
    <style>body{font-family:system-ui,-apple-system,sans-serif;padding:32px;max-width:800px;margin:0 auto;color:#1a1a1a}
    table{width:100%;border-collapse:collapse;margin-top:6px}th,td{text-align:left;padding:6px;border-bottom:1px solid #ddd;font-size:12px}
    th{background:#f9f9f9}h1{font-size:20px}h2{font-size:15px}
</style>
    </head><body>${body}</body></html>`)
  w.document.close()
  setTimeout(() => w.print(), 250)
}

function getLibFormData() {
  const catsEl = document.getElementById('f-lib-cats')
  const cats = catsEl ? Array.from(catsEl.selectedOptions).map(o => o.value) : []
  return {
    scientificName: document.getElementById('f-lib-sci')?.value?.trim() || '',
    customVialName: document.getElementById('f-lib-vial')?.value?.trim() || '',
    aliases:        (document.getElementById('f-lib-aliases')?.value || '').split(',').map(a=>a.trim()).filter(Boolean),
    categories:     cats,
    isBlend:        document.getElementById('f-lib-blend')?.checked || false,
    active:         document.getElementById('f-lib-active')?.checked !== false,
  }
}
function createCategoryFromModal() {
  const input = document.getElementById('f-lib-newcat')
  const label = (input?.value||'').trim()
  if (!label) return
  if (!addCustomCategory(label)) return  // shows toast if duplicate/invalid
  // Inject the new option into the select and select it, preserving other form fields
  const sel = document.getElementById('f-lib-cats')
  if (sel) {
    const opt = document.createElement('option')
    opt.value = label; opt.textContent = label; opt.selected = true
    sel.appendChild(opt)
  }
  input.value = ''
  showToast(`Category "${label}" created`)
}

function createCategoryFromPeptideModal() {
  const input = document.getElementById('f-pep-newcat')
  const label = (input?.value || '').trim()
  if (!label) { showToast('Enter a category name'); return }
  const select = document.getElementById('f-pep-cats')
  if (select) {
    const existing = Array.from(select.options).find(option => option.value.toLowerCase() === label.toLowerCase())
    if (existing) {
      existing.selected = true
      input.value = ''
      showToast(`Category "${existing.value}" selected`)
      return
    }
    const option = document.createElement('option')
    option.value = label
    option.textContent = label
    option.selected = true
    option.dataset.pendingCategory = 'true'
    select.appendChild(option)
  }
  if (!S.modalData) S.modalData = {}
  if (!Array.isArray(S.modalData.pendingPeptideCategories)) S.modalData.pendingPeptideCategories = []
  if (!S.modalData.pendingPeptideCategories.some(category => category.toLowerCase() === label.toLowerCase())) {
    S.modalData.pendingPeptideCategories.push(label)
  }
  input.value = ''
  showToast(`Category "${label}" will be created when you save the peptide`)
}

function saveAddLibraryEntry() {
  const data = getLibFormData()
  if (!data.scientificName) { showToast('Scientific name is required'); return }
  const entry = { id: 'lib_'+uid(), ...data }
  S.peptideLibrary.push(entry)
  logChange('library', entry.id, 'created', `Added library entry "${data.scientificName}"`)
  save(); closeModal(); render(); showToast('Library entry added')
}
function saveEditLibraryEntry(libId) {
  const e = S.peptideLibrary.find(x => x.id === libId)
  if (!e) return
  const data = getLibFormData()
  if (!data.scientificName) { showToast('Scientific name is required'); return }
  Object.assign(e, data)
  logChange('library', e.id, 'updated', `Updated library entry "${data.scientificName}"`)
  save(); closeModal(); render(); showToast('Library entry updated')
}
function toggleLibraryActive(libId) {
  const e = S.peptideLibrary.find(x => x.id === libId)
  if (!e) return
  e.active = !e.active
  logChange('library', e.id, 'updated', `${e.active?'Activated':'Deactivated'} "${e.scientificName}"`)
  save(); render()
}

// ── Notes CRUD ────────────────────────────────────────
function saveAddNote() {
  const title = document.getElementById('f-note-title')?.value?.trim()
  if (!title) { showToast('Title is required'); return }
  S.notes.push({
    id: 'n_' + uid(),
    date: document.getElementById('f-note-date')?.value || localDateKey(),
    title,
    body: document.getElementById('f-note-body')?.value?.trim() || '',
    peptideId: document.getElementById('f-note-pep')?.value || ''
  })
  save(); closeModal(); render(); showToast('Note added')
}

function saveEditNote(noteId) {
  const note = S.notes.find(n => n.id === noteId)
  if (!note) return
  const title = document.getElementById('f-note-title')?.value?.trim()
  if (!title) { showToast('Title is required'); return }
  note.date      = document.getElementById('f-note-date')?.value || note.date
  note.title     = title
  note.body      = document.getElementById('f-note-body')?.value?.trim() || ''
  note.peptideId = document.getElementById('f-note-pep')?.value || ''
  save(); closeModal(); render(); showToast('Note updated')
}

function deleteNote(noteId) {
  appConfirm('Delete this note?', () => {
    S.notes = S.notes.filter(n => n.id !== noteId)
    save(); render(); showToast('Note deleted')
  })
}

// ── Analytics month drill-down ────────────────────────
function showMonthDetail(monthKey) {
  const [y, m] = monthKey.split('-')
  const label = new Date(+y, +m-1, 15).toLocaleDateString('en-US', {month:'long', year:'numeric'})
  const injs = S.injections
    .filter(i => i.date.startsWith(monthKey))
    .sort((a,b) => a.date.localeCompare(b.date) || injTimeMinutes(a.time) - injTimeMinutes(b.time))
  S.modal = 'monthDetail'
  S.modalData = { label, injs, monthKey }
  render()
}


function saveAddLocation() {
  const name = document.getElementById('f-loc-name')?.value?.trim()
  if (!name) { showToast('Name is required'); return }
  if (S.storageLocations.find(l => l.name.toLowerCase() === name.toLowerCase())) {
    showToast('A location with that name already exists'); return
  }
  const totalCapacity = +(document.getElementById('f-loc-capacity')?.value || 0)
  S.storageLocations.push({ id: 'loc_' + uid(), name, totalCapacity })
  save(); closeModal(); render(); showToast('Location added')
}

async function saveEditLocation(locId) {
  const loc = S.storageLocations.find(l => l.id === locId)
  if (!loc) return
  const name = document.getElementById('f-loc-name')?.value?.trim()
  if (!name) { showToast('Name is required'); return }
  loc.name = name
  loc.totalCapacity = +(document.getElementById('f-loc-capacity')?.value || 0)
  save(); closeModal(); render(); showToast('Location updated')
}

async function deleteLocation(locId) {
  const loc = S.storageLocations.find(l => l.id === locId)
  // Check if any SKU references this location
  let inUse = false
  for (const supply of (S.injectionSupplies||[])) {
    for (const s of (supply.skus||[])) {
      if ((s.locations||[]).some(l => l.locationId === locId)) { inUse = true; break }
    }
    if (inUse) break
  }
  if (inUse) {
    if (!await asyncConfirm(`${loc?.name} is assigned to one or more SKUs. Delete it anyway?\n\nSKU assignments will be removed.`)) return
    // Remove from all SKUs
    for (const supply of (S.injectionSupplies||[])) {
      for (const s of (supply.skus||[])) {
        s.locations = (s.locations||[]).filter(l => l.locationId !== locId)
      }
    }
  } else {
    if (!await asyncConfirm(`Delete location ${loc?.name}?`)) return
  }
  S.storageLocations = S.storageLocations.filter(l => l.id !== locId)
  save(); render(); showToast('Location deleted')
}


async function setSettingMode(mode) {
  S.settings.syncMode = mode
  if (window.api) {
    const result = await window.api.saveSettings({ ...S.settings, syncMode: mode })
    if (result.ok) { dataDir = result.dataDir; S.settings.dataDir = dataDir }
  }
  render()
  showToast('Sync mode saved — restart the app for it to take effect on existing data')
}

async function browseCustomFolder() {
  if (!window.api) return
  const folder = await window.api.pickFolder()
  if (!folder) return
  S.settings.customDir = folder
  const result = await window.api.saveSettings({ ...S.settings, syncMode: 'custom', customDir: folder })
  if (!result.ok) { showToast(result.error || 'Could not save custom folder'); return }
  dataDir = result.dataDir; S.settings.dataDir = dataDir
  render()
  showToast('Custom folder saved')
}

export {
  asyncConfirm,
  appConfirm,
  copyToClipboard,
  trapFocus,
  init,
  deleteInjection,
  renderMiniCalendar,
  saveAnthropicKeyFromSettings,
  testAnthropicConnection,
  saveAnthropicKey,
  LAB_EXTRACT_PROMPT,
  fileToBase64,
  handleAILabDrop,
  SUPP_CSV_HEADERS,
  downloadSuppTemplate,
  importSuppCSV,
  parseSuppCSV,
  exportSuppCSV,
  exportInjSuppliesCSV,
  getSuppFormData,
  toggleSuppDosageOverride,
  toggleSuppProtocolLinks,
  updateSuppCalc,
  updateRefillCount,
  refillFilterSet,
  applyRefills,
  saveAddSupplement,
  saveEditSupplement,
  deleteSupplement,
  getUserFormData,
  saveAddUser,
  saveEditUser,
  deleteUser,
  PROTOCOL_DISCLAIMER,
  printProviderSummary,
  getLibFormData,
  createCategoryFromModal,
  createCategoryFromPeptideModal,
  saveAddLibraryEntry,
  saveEditLibraryEntry,
  toggleLibraryActive,
  saveAddNote,
  saveEditNote,
  deleteNote,
  showMonthDetail,
  saveAddLocation,
  saveEditLocation,
  deleteLocation,
  setSettingMode,
  browseCustomFolder
}
